'use client'

import Dropdown from 'react-bootstrap/Dropdown';
import Image from 'next/image'
import { encode } from '@/src/utils/coder';
import CustomSplitButton from './Button.CustomSplitButton';
import authMenu from "../auth.menu.json"
import { Menu } from "@/src/types/menu.types";
import { useRouter } from "next/navigation";
import { logout } from "@/src/utils/router";

export default function AuthMenu({
  name,
  designation,
  url

}: {
    name: string;
    designation: string;
    url: string;
  })
{
  const router = useRouter();
  
  return (
    <div className="d-flex align-items-center gap-3 ps-3 border-start border-secondary-subtle">
      <div className="text-end d-none d-sm-block">
        <p className="mb-1 fs-6 fw-bold text-dark lh-sm">{name}</p>
        <p className="mb-1 text-secondary" style={{ fontSize: "10px" }}>{designation}</p>
        <CustomSplitButton
          id="auth-menu"
          variant="success"
          title="Logout"
          className=""
          onClick={() => { localStorage.setItem("selected", JSON.stringify({})); logout(router); }}
        >
          {
            Object.entries(authMenu as Menu).map(
              ([title, item], idx) => {
                if (title.startsWith("-")) {
                  return (<Dropdown.Divider key={`${idx}`} />);
                }
                return (
                  <Dropdown.Item key={`${idx}`} href={item?.route?.[0] ? item.route[0] + '?c=' + encode(title) : ''}>{title}</Dropdown.Item>
                )
              }
            )
          }
        </CustomSplitButton>
      </div>
      <div className="position-relative">
        <Image
          src={url}
          alt="Profile"
          loading={"eager"}
          width={64}
          height={64}
          className="position-static rounded-pill object-fit-cover"
          style={{ boxShadow: "0 0 0 2px #f1f5f9" }}
        />
      </div>
      
    </div>
  );
}
